import React from 'react';
import { useParams } from 'react-router-dom';
import { Grid, Paper } from '@mui/material';
import DashboardLayout from '../../../shared/layout/DashboardLayout';
import CapacidadFuncional from '../components/CapacidadFuncional';

export default function CreateCapacidadFuncionalPage() {
  const { idPaciente } = useParams();

  return (
    <DashboardLayout>
      <Grid item xs={12}>
        <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
          <CapacidadFuncional idPaciente={idPaciente} />
        </Paper>
      </Grid>
    </DashboardLayout>
  );
}
